import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select';
import { loadTomSelect } from "../libs/tom-select";

// Connects to data-controller="tom-select"
export default class extends Controller {
  static values = {
    settings: Object
  };

  connect() {
    if (this.element.classList.contains('tomselected')) return;
    if (this.element.classList.contains('no-ts')) return;

    const readonly = this.element.getAttribute("readonly") === "readonly";

    if (this.hasSettingsValue) {
      this.ts = new TomSelect(this.element, this.settingsValue);
    } else if (this.element.classList.contains('tomselect-ajax')) {
      this.ts = loadTomSelect(this.element, true);
    } else {
      this.ts = loadTomSelect(this.element, false);
    }

    // For some reason tom-select clears it after initialization.
    if (readonly) {
      this.element.setAttribute("readonly", "readonly")
      this.element.parentElement.querySelector(".ts-wrapper").classList.add("readonly");
    }
  }

  disconnect() {
    if (this.ts) {
      this.ts.destroy();
      this.ts = null;
    }

    if (this.element.classList.contains('tomselected')) {
      this.element.classList.remove('tomselected');
    }
  }
}
